import { formatCurrency } from '@hue/design-system';
import type { Metric } from '../../lib/api.js';

/// Como um indicador é dito na tela. Sem valor vira travessão, nunca zero: o card já explica ao
/// lado qual premissa falta, e um zero ali seria lido como resultado.
export function formatMetric(metric: Metric | undefined): string {
  if (!metric || metric.value === null) return '—';
  switch (metric.format) {
    case 'money':
      return formatCurrency(metric.value);
    case 'percent':
      return `${formatDecimal(metric.value * 100, 1)}%`;
    case 'ratio':
      return `${formatDecimal(metric.value, 2)}×`;
    default:
      return `${formatDecimal(metric.value, 1)} ${metric.value === 1 ? 'mês' : 'meses'}`;
  }
}

function formatDecimal(value: number, places: number): string {
  return value.toFixed(places).replace('.', ',');
}

/// Taxa e múltiplo viajam como inteiro (pontos-base, centésimos) e se digitam como número decimal.
/// A conversão fica aqui, e não no campo, porque o inteiro é o que a API entende e o decimal é o
/// que a pessoa escreve — inclusive com vírgula, que é como se escreve em português.
export function parseScaled(text: string, scale: number): number | null {
  const normalized = text.replace(/\s/gu, '').replace(',', '.');
  if (normalized === '') return null;
  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) return null;
  return Math.round(parsed * scale);
}

export function formatScaled(value: number | null, scale: number): string {
  if (value === null) return '';
  return String(value / scale).replace('.', ',');
}
